/**
 * Canonical public contact details for the shop.
 *
 * Provenance (verified 2026-09-05): the phone and address match the active
 * ShopLocation row in the database ("Choice Graphics Edmonton South") and the
 * legal-entity table in src/content/pages/legal.mdx, rewritten 2026-09-04.
 * The general inbox is the one every legal page names for questions and
 * warranty reports. Pages that can read the ShopLocation record should prefer
 * it (address, hours); these constants are the fallback and the value for
 * static chrome (CTA bands, JSON-LD) that has no database access.
 *
 * Do not add a second number here. If the shop's number changes, update the
 * ShopLocation row and this file together.
 */
export const CONTACT = {
  /** Display form. */
  phoneDisplay: '780-640-1600',
  /** tel: form (E.164). */
  phoneTel: '+17806401600',
  /** JSON-LD / schema.org form. */
  phoneSchema: '+1-780-640-1600',
  email: 'info@choice.graphics',
  address: {
    street: '8739 53 Ave NW',
    city: 'Edmonton',
    region: 'AB',
    postal: 'T6E 5E9',
  },
} as const

export const CONTACT_PATHS = {
  contact: '/contact',
  book: '/book',
  quote: '/quote',
  fleetQuote: '/fleet-quote',
  instantQuote: '/get-a-quote',
  warrantyClaim: '/warranty-claim',
  warrantyPolicy: '/warranty',
} as const
